import React, { forwardRef } from "react";
import isURL from "validator/lib/isURL";
import { Control, RegisterOptions, UseControllerProps } from "react-hook-form";

import { CpInputField } from "./cp-input-field.component";

type CpInputFieldUrlProps = {
  control: Control<any>;
  controllerOptions?: Omit<UseControllerProps, "name" | "control" | "rules">;
  fieldName: string;
  rules?: RegisterOptions;
} & Omit<
  React.ComponentPropsWithRef<typeof CpInputField>,
  "control" | "fieldName" | "rules" | "controllerOptions"
>;

export const CpInputFieldUrl = forwardRef<
  HTMLInputElement,
  CpInputFieldUrlProps
>(function CpInputFieldUrl(props, ref) {
  const {
    control,
    controllerOptions,
    fieldName,
    rules = {},
    ...inputProps
  } = props;

  return (
    <CpInputField
      control={control}
      controllerOptions={controllerOptions}
      fieldName={fieldName}
      rules={{
        ...rules,
        validate: {
          ...rules?.validate,
          isValidUrl: (v: unknown) => {
            const value = v as string;
            return !value?.length || isURL(value) || "Field must be URL";
          },
        },
      }}
      ref={ref}
      {...inputProps}
    />
  );
});
